(function () {
	'use strict';

	angular.module('smb-app')
		.directive('smbHome', [HomeDirective])
		.controller('HomeController',
		[
			'gettextCatalog',
			'$mdMedia',
			'smbToDoListDataStore',
			'smbToolbarService',
			HomeController
		]);

	var templateUrl = require('./home.template');
	function HomeDirective() {
		return {
			restrict: 'E',
			controller: HomeController,
			controllerAs: 'vm',
			templateUrl: templateUrl,
			bindToController: true,
			scope: {}
		};
	}

	function HomeController(gettextCatalog, $mdMedia, smbToDoListDataStore, smbToolbarService) {
		smbToolbarService.reset();

		var vm = this;
		vm.media = $mdMedia;
		vm.todoListDS = smbToDoListDataStore;
		vm.items = [
			{ label: gettextCatalog.getString('Find Documents'), icon: 'search', state: 'search.contentTypeGroups' },
			{ label: gettextCatalog.getString('Add Documents'), icon: 'note_add', state: 'import.contentTypeGroups' },
			{ label: gettextCatalog.getString('My To-Do List'), icon: 'assignment', state: 'todo.list', isTodoList: true }
		];
	}
}());


//////////////////
// WEBPACK FOOTER
// ./app/components/home/home.js
// module id = 87
// module chunks = 1